import React, { createContext, useContext } from 'react';
import type { PropsWithChildren } from 'react';
import { useKostnadsKalkyleController } from './useKostnadsKalkyleController';
import type { KostnadsKalkyleProps } from './KostnadsKalkyleProps';

type KostnadsKalkyleProviderProps = PropsWithChildren<KostnadsKalkyleProps>;

const KostnadsKalkyleContext = createContext<
    ReturnType<typeof useKostnadsKalkyleController> | undefined
>(undefined);

export const KostnadsKalkyleProvider = ({
    field,
    prosessInstansId,
    prosjektId,
    isReadOnly,
    isRequired,
    prosjektNavn,
    children,
}: KostnadsKalkyleProviderProps) => {
    const controller = useKostnadsKalkyleController({
        field,
        prosessInstansId,
        prosjektId,
        isReadOnly,
        isRequired,
        prosjektNavn,
    });
    return (
        <KostnadsKalkyleContext.Provider value={controller}>
            {children}
        </KostnadsKalkyleContext.Provider>
    );
};

export const useKostnadsKalkyleContext = () => {
    const context = useContext(KostnadsKalkyleContext);
    if (!context) {
        throw new Error(
            'useKostnadsKalkyleContext must be used within a KostnadsKalkyleProvider',
        );
    }
    return context;
};
